import styled from 'styled-components';

export const Logo = styled.img.attrs(() => ({
  src: 'https://axescores.com/images/logo.png',
}))`
  height: 40px;
  width: auto;
`;
